import { dtoToEntity, ReportStaysDTO, ReportStaysResultDTO } from "./reportStays.dto";
import { ReportStaysEntity } from "../domain/reportStays.entity";
import { IHttpClient } from "../../../lib/http";
import { useMemo } from "react";

export interface ReportStaysRequest {
  checkIn: string;
  checkOut: string;
  groupBy: string[];
  hotelTickers: string;
  orderBy: {
    [K in keyof Partial<ReportStaysResultDTO>]: "asc" | "desc";
  };
  showComments: boolean;
  statusConfig: number[];
}

export interface GetReportStaysRequest {
  request: ReportStaysRequest;
  size: number;
  page: number;
}

export interface ReportStaysSummarizeColumns {
  sumText: string;
  avgText: string;
}

export interface ReportStaysResponse {
  report: ReportStaysEntity[];
  totalResults: number;
}

async function getStaysPerDayReport({
  request,
  httpClient,
  size,
  page,
  sumText,
  avgText,
}: GetReportStaysRequest & ReportStaysSummarizeColumns & { httpClient: IHttpClient }): Promise<ReportStaysResponse> {
  const reportDTO: ReportStaysDTO = await httpClient.post<ReportStaysRequest, ReportStaysDTO>(
    `/api/report/stays?size=${size}&page=${page}`, {
      ...request,
    });
  return {
    report: dtoToEntity(reportDTO, sumText, avgText),
    totalResults: reportDTO.totalResults,
  };
}

export const useReportStaysApi = (httpClient: IHttpClient) => {
  return useMemo(
    () => ({
      getStaysPerDayReport: (props: GetReportStaysRequest & ReportStaysSummarizeColumns) =>
        getStaysPerDayReport({ httpClient, ...props }),
    }),
    [httpClient],
  );
};
